const sectionPostArchive = () => {
  if (document.querySelector('.js-show-more')) {
    let iter = 1;
    const visible = window.innerWidth < 768 ? 1 : 3;
    if (
      iter >=
      document.querySelectorAll('.js-to-show-more .o-flex__item').length /
        visible
    ) {
      document
        .querySelector('.js-show-more')
        .parentElement.classList.add('u-hidden');
    }
    document.querySelector('.js-show-more').addEventListener('click', e => {
      e.preventDefault();
      document
        .querySelectorAll(`.js-to-show-more .o-flex__item.u-hidden`)
        .forEach((elem, index) => {
          if (index < visible) {
            elem.classList.remove('u-hidden');
          }
        });
      iter++;
      if (
        iter >=
        document.querySelectorAll('.js-to-show-more .o-flex__item').length /
          visible
      ) {
        document
          .querySelector('.js-show-more')
          .parentElement.classList.add('u-hidden');
      }
    });
  }
};

export default sectionPostArchive;



// WEBPACK FOOTER //
// ./wp/wp-content/themes/kerris-select-chisel/src/scripts/modules/section-post-archive.js